import { Component, Inject, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonService } from 'src/app/services/common.service';
import Swal from 'sweetalert2/dist/sweetalert2.js';

@Component({
  selector: 'app-change-status-of-task',
  templateUrl: './change-status-of-task.component.html',
  styleUrls: ['./change-status-of-task.component.css']
})
export class ChangeStatusOfTaskComponent implements OnInit {
  injectedData: any;
  taskStatusForm: FormGroup;
  someObject: any = {'vivek':'mahajan'};
  selectedTaskStatus: string = '';

  constructor(public dialogRef: MatDialogRef<ChangeStatusOfTaskComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,private commonService:CommonService) {

      this.injectedData = data;

     }

  ngOnInit(): void {
    this.selectTaskStatus(this.injectedData.status.charAt(0).toUpperCase() + this.injectedData.status.slice(1))
  }
  selectTaskStatus(status: string): void {
    this.selectedTaskStatus = status;
  }
  closeModal(): void {
    this.dialogRef.close();
  }
  submit(task: any, data: any){
console.log('status',data)
if(data == 'Started'){
  task.status = 'inprogress';
}else if(data == 'Assigned'){
  task.status = 'assigned';
}
else if(data == 'Completed'){
task.status = 'completed';
}
else if(data == 'Unassigned'){
  task.status = 'unassigned'
}
else if(data == 'Acknowledged'){
  task.status ='acknowledged'
}
    
    this.commonService.putRequest(`traccartasks/${task.id}`, task).then((resp: any) => {
      if (resp?.status) {
        // this.driverAssignedEvent.emit(resp);
        // this.commonService.commonModel.next(false);
        Swal.fire({
          icon: "success",
          title: `Task updated successfully`,
          showConfirmButton: false,
          timer: 1500,
        });        
      }      
    }, err => {
      Swal.fire({
        icon: "error",
        title: "Something Went Wrong",
        showConfirmButton: false,
        timer: 1500,
      });
    });
    this.closeModal();
  }


}
